"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is Node
 * @param obj The object to check
 */
function isNode(obj) {
    return safeInstanceOf_1.default(obj, 'Node');
}
exports.default = isNode;
//# sourceMappingURL=isNode.js.map